import axios from 'axios';

const getTransportadorasCompra = (path, params) => axios.get(path, { params });

export default {
  getTransportadorasCompra,
};
